"use client";

import { Suspense, lazy } from "react";

// Lazy imports
const ContactSection = lazy(() => import("../Home/ContactSection"));
const AffiliateSearch = lazy(() => import("./AffiliateSearch"));
const HelpCenterAffiliateBanners = lazy(
  () => import("./HelpCenterAffiliateBanners")
);
const HelpCenterFaq = lazy(() => import("./HelpCenterFaq"));

const HelpCenterMain = () => {
  return (
    <Suspense
      fallback={
        <div className="w-full py-20 text-center text-white">Loading...</div>
      }
    >
      <AffiliateSearch />
      <HelpCenterFaq />
      <HelpCenterAffiliateBanners />
      <ContactSection />
    </Suspense>
  );
};

export default HelpCenterMain;
